import React from "react";

import S from "./styles.js";

function Container({ children, ...props }) {

  return <S.Container {...props}>{children}</S.Container>;
}

export default Container;
